export default __webpack_public_path__ + "static/media/dollar-voucher.bfb231b9.png";